import type { Module } from '@moonpig/web-shared-products'

export const createCardOutOfStockConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [{ __typename: 'ModuleImages' }],
      right: [
        { __typename: 'ModuleTitle' },
        { __typename: 'ModuleOutOfStock' },
      ],
    },
  ]
}
